import React, {Component} from 'react';
import styles from "./home.module.css";
import logo from '../../img/logo2.png';
import close from '../../img/close.svg';
import search from '../../img/search.svg';
import chexiao from '../../img/chexiao.svg';
import badge from '../../img/badge.svg';
import dianzan from '../../img/dianzan.svg';
import duoRen from '../../img/ic_evaluation_duoren.png';
import ic_checked from '../../img/ic_checked.svg';
import ic_unchecked from '../../img/ic_unchecked.png';
import defaultImg from '../../img/bee.png';
import {FILE_URL} from "../../util/constants";
import MyImg from '../myimg/myimg.jsx';

import icHz from '../../img/ic_hz_white.svg';
import icStu from '../../img/ic_stu_white.svg';
import icPj from '../../img/ic_pingjia_white.svg';
import icHuodong from '../../img/ic_huodong.svg';

import icPaiming from '../../img/ic_paiming.svg';
import icClassinfo from '../../img/ic_classinfo.svg';
import icZiping from '../../img/ic_ziping.svg';
import icGuanli from '../../img/icon_guanli.png';

import icHuodongShenhe from './ic_huodong.png';

const Home = props => (

    <div className={styles.root}>
        <div className={styles.menubar}>
            <img className={styles["img-logo"]} src={defaultImg}/>
            <div className={styles["title-tianyuan"]}>幸福田园</div>

            <div className={styles["div-info"]}>
                <div className={styles.divider}></div>
                <div className={styles["class-name"]}>{props.banji_name}</div>

                <div className={styles["bt-div"]} onClick={props.openRecordBadge}>
                    <img className={styles["img-badge"]} src={icHz}/>
                    <div>{props.class_badge_num}</div>
                </div>

                <div className={styles["bt-div"]} onClick={props.openRecordClass}>
                    <img className={styles["img-badge"]} src={icPj}/>
                    <div>{props.class_dianzan_num}</div>
                </div>

                <div className={styles["bt-div"]} onClick={props.openRecord}>
                    <img className={styles["img-badge"]} src={icStu}/>
                    <div>{props.class_stu_dianzan_num}</div>
                </div>

                <div className={styles["bt-class-pingjia"]} onClick={props.openBanjiReason}>评价班级</div>
            </div>

            <div className={styles["container-right"]}>

                {sessionStorage.getItem('admin')=='1'?
                    <img className={styles["img-laba"]} src={icHuodongShenhe} onClick={props.openHuodongShenheModal}/>
                :null}


                <img className={styles["img-paiming"]} src={icClassinfo} onClick={props.openClassdataModal}/>
                <img className={styles["img-paiming"]} src={icPaiming} onClick={props.openRankingListModal}/>

                {/*<img className={styles["img-ziping"]} src={icZiping} onClick={props.openZipingListModal}/>*/}

                {props.huodong_status=='1'?
                    <img className={styles["img-classdata"]} src={icHuodong} onClick={props.openActivityListModal}/>
                :null}

                <div className={styles["container-info"]}
                     onClick={props.logOut}>
                    <MyImg src={FILE_URL + sessionStorage.getItem('teacherimg')}/>
                    <div className={styles["text-username"]}>{sessionStorage.getItem('name')}</div>
                </div>

            </div>
        </div>

        <div className={styles["container-toolbar"]}>
            <div className={styles.divInput}>
                <div className={styles.input2} onClick={props.openClassValue}>
                    <div
                        className={styles.title}>{props.juese_name == '' ? '' : props.juese_name}</div>
                    <div className={styles.arrow}></div>
                </div>
                <div id='option' className={
                    props.showJuese ? styles.list2 : styles.list}>
                    <ul className={styles.ul}>
                        {
                            props.jueseList.map((item, index) => {
                                return (
                                    <li className={styles.li}
                                        onClick={props.getClassValue.bind(null, item.juese_code, item.juese_name, index)}
                                        key={item.juese_code}>{item.juese_name}</li>);
                            })
                        }
                    </ul>
                </div>
            </div>

            <div className={styles.divInput}>
                <div className={styles.input2} onClick={props.openClassValue2}>
                    <div
                        className={styles.title}>{props.nianji_name == '' ? '' : props.nianji_name}</div>
                    <div className={styles.arrow}></div>
                </div>
                <div id='option' className={
                    props.showNianji ? styles.list2 : styles.list}>
                    <ul className={styles.ul}>
                        {
                            props.nianjiList.map((item) => {
                                return (
                                    <li className={styles.li}
                                        onClick={props.getClassValue2.bind(null, item.nianji_code, item.nianji_name)}
                                        key={item.nianji_code}>{item.nianji_name}</li>);
                            })
                        }
                    </ul>
                </div>
            </div>

            <div className={styles.divInput}>
                <div className={styles.input2} onClick={props.openClassValue3}>
                    <div
                        className={styles.title}>{props.banji_name == '' ? '' : props.banji_name}</div>
                    <div className={styles.arrow}></div>
                </div>
                <div id='option' className={
                    props.showBanji ? styles.list2 : styles.list}>
                    <ul className={styles.ul}>
                        {
                            props.banjiList.map((item) => {
                                return (
                                    <li className={styles.li}
                                        onClick={props.getClassValue3.bind(null, item.classcode, item.name)}
                                        key={item.classcode}>{item.name}</li>);
                            })
                        }
                    </ul>
                </div>
            </div>

            <div className={styles["container-search"]}>
                <img className={styles["img-search"]} src={search}/>
                <input
                    className={styles["input-name"]}
                    placeholder='搜索姓名'
                    value={props.searchInputValue}
                    autoComplete="off"
                    onChange={(e) => {
                        props.searchInputChange(e.target.value);
                    }}
                />
            </div>

            <div className={styles["bt-search"]} onClick={props.search}>搜索</div>


            {props.duorenStatus ? null :
                <div className={styles['bt-sort']} onClick={props.pingjiaDuoren}>
                    <img className={styles['img-sort']}
                         src={duoRen}
                    />
                    <div className={styles.sort}>评价多人</div>
                </div>}

            {props.duorenStatus ?
                <div className={styles.checkall}>
                    <img className={styles['check-img']}
                         src={props.selectAllStatus ? ic_checked : ic_unchecked}
                         onClick={props.selectAll}/>

                    <div>全选</div>
                </div>
                : null}



            <div className={styles['bt-sort']} onClick={props.classGuanli}>
                <img className={styles['img-guanli']}
                     src={icGuanli}
                />
                <div className={styles.sort}>班级管理</div>
            </div>


            {/*{props.duorenStatus ? null :*/}
            {/*<div className={styles['text-jilu']} onClick={props.openRecord}>评价记录</div>}*/}

            {props.duorenStatus ?
                <div className={styles['div-bt-right']}>
                    <button className={styles['bt-go']} onClick={props.showReasonPrompt2}>去评价</button>
                    <button className={styles['bt-cancel']} onClick={props.cancelPingjiaDuoren}>取消</button>
                </div>
                : null}


            {/*<div className={styles["container-chexiao"]}>*/}
            {/*<img src={chexiao}/>*/}
            {/*<div className={styles["text-chexiao"]}>撤销评价</div>*/}
            {/*</div>*/}

        </div>

        {props.studentList.length > 0 ?

            <div className={styles.abc}>

                <div className={styles["list-wrapper"]}>
                    {
                        props.studentList.map((item, index, array) => {
                            return (
                                <div className={styles["list-item"]}
                                     onClick={props.showReasonPrompt.bind(null, item.name, item.img, item.pid)}>

                                    {props.duorenStatus ?
                                        <img className={styles['item-checkbox']}
                                             src={item.checked ? ic_checked : ic_unchecked}
                                             onClick={props.selectChildCheckBox.bind(null, item.name)}
                                        />
                                        : null}

                                    <div className={styles["list-item-top"]}>
                                        <img
                                            className={styles["list-item-img"]}
                                            src={item.img}
                                            onError={props.handleImageErrored.bind(this, index)}
                                        />

                                        {/*<MyImg  type='homelist' src={FILE_URL+item.img}/>*/}

                                        <div className={styles["list-item-name"]}>{item.name}</div>
                                        <div className={styles["list-item-num"]}>
                                            <img className={styles["list-item-icon"]} src={badge}/>
                                            <div className={styles["list-item-num-text"]}>{item.badge}</div>

                                            <img className={styles["list-item-icon2"]} src={dianzan}/>
                                            <div className={styles["list-item-num-text"]}>{item.score}</div>
                                        </div>
                                    </div>

                                    <div className={styles["list-item-bottom"]}>

                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            : (<div className={styles['no-data']}>暂无学生</div>)}

    </div>

)

export default Home;
